module.exports = __webpack_public_path__ + "static/media/GreatSouthernHerald-devicecomp-min@2x.1dfea742.png";